import { FC, useEffect } from 'react';
import { useToggle } from 'react-use';
import styles from './index.module.scss';

interface OwnProps {
  selected?: boolean;
  onSelected?(value: boolean): void;
  className?: string;
}

const SwitchOnOff: FC<OwnProps> = (props) => {
  const { selected = true, onSelected, className } = props;
  const [visible, toggleVisible] = useToggle(true);

  const handleVisible = (value: boolean) => {
    toggleVisible(value);
    if (onSelected) onSelected(value);
  };

  useEffect(() => {
    toggleVisible(selected);
  }, [selected]);

  return (
    <div
      className={`${styles.switch} ${visible ? styles.active : ''} ${className} `}
      onClick={() => handleVisible(!visible)}
    >
      <div className={styles.on}>On</div>
      <div className={styles.off}>Off</div>
    </div>
  );
};

export default SwitchOnOff;
